import React, { useEffect, useRef, useState } from "react";
import { FloatingLabel, Form } from "react-bootstrap";

interface TextAreaState {
  label: string;
  value: any;
  onUpdate: any;
  rows?: number;
  labelAbove?: boolean;
  css?: string;
  hasFocus?: boolean;
  disabled?: boolean;
}

const Textarea = ({
  label,
  value,
  onUpdate,
  rows = 3,
  labelAbove = false,
  css = "form-floating-label-textarea",
  hasFocus = false,
  disabled = false,
}: TextAreaState) => {
  const inputRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (hasFocus) {
      inputRef?.current?.focus();
    }
  }, []);

  const labelRef = useRef<HTMLLabelElement>(null);
  const [paddingTop, setPaddingTop] = useState("1.5rem");

  useEffect(() => {
    if (labelRef.current) {
      const labelHeight = labelRef.current.offsetHeight;
      // Adjust padding dynamically
      const dynamicPadding = Math.max(labelHeight + 12, 24); // 8px buffer
      setPaddingTop(`${dynamicPadding}px`);
    }
  }, [label]);

  return (
    <FloatingLabel
      controlId="floatingInput"
      label={labelAbove ? <span ref={labelRef}>{label}</span> : label}
      className={css}
      style={labelAbove ? { paddingTop } : {}}
    >
      <Form.Control
        as="textarea"
        type="textarea"
        data-testid="textarea"
        value={value}
        onChange={onUpdate}
        style={{ height: "auto" }}
        disabled={disabled}
        rows={rows}
        ref={inputRef}
      />
    </FloatingLabel>
  );
};

export default Textarea;
